import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_ask_dialog = _resolveComponent("ontos-ask-dialog")!

  return (_ctx.leaving)
    ? (_openBlock(), _createBlock(_component_ontos_ask_dialog, {
        key: 0,
        title: _ctx.$tt('unsaved-changes'),
        message: _ctx.message,
        actions: _ctx.actions,
        onPick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit($event === 'leave' ? 'confirmed' : 'cancelled'))),
        onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancelled')))
      }, null, 8, ["title", "message", "actions"]))
    : _createCommentVNode("", true)
}